'use client';

import { format } from 'date-fns';
import { Calendar as CalendarIcon, ChevronDownIcon } from 'lucide-react';
import { useState } from 'react';
import type { Matcher } from 'react-day-picker';

import { Button } from './button';
import { Calendar } from './calendar';
import { FormControl, useFormField } from './form';
import { Popover, PopoverContent, PopoverTrigger } from './popover';
import { cn } from './utils/cn';

function DatePicker({
  value,
  onChange,
  disabledDates,
}: {
  value: Date | undefined;
  onChange: (date: Date | undefined) => void;
  disabledDates?: Matcher;
}) {
  const { error, name } = useFormField();
  const [open, setOpen] = useState(false);

  return (
    <>
      {value ? <input name={name} type='hidden' value={format(value, 'dd/MM/yyyy')} /> : null}
      <Popover onOpenChange={setOpen} open={open}>
        <PopoverTrigger asChild>
          <FormControl>
            <Button
              className={cn(
                'w-full justify-start font-normal',
                !value && 'text-muted-foreground',
                error && 'border-destructive',
              )}
              variant='outline'
            >
              <div className='flex grow gap-1'>
                <CalendarIcon className='h-4 w-4 opacity-50' />
                {value ? format(value, 'dd/MM/yyyy') : <span>Pick a date</span>}
              </div>
              <ChevronDownIcon className='ml-auto h-4 w-4 opacity-50' />
            </Button>
          </FormControl>
        </PopoverTrigger>
        <PopoverContent align='start' className='w-auto p-0'>
          <Calendar
            disabled={disabledDates}
            initialFocus
            mode='single'
            onDayClick={() => setOpen(false)}
            onSelect={onChange}
            selected={value}
          />
        </PopoverContent>
      </Popover>
    </>
  );
}

export { DatePicker };
